export enum NewsTypeEnum {
	BIG_VERTICAL = 0,
	BIG_HORIZONTAL = 1,
	SMALL = 2,

}
